import { ChevronRightIcon } from "@chakra-ui/icons";
import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

type AnimatedChevronIconProps = IconProps & {
  distance?: string | number;
};

/**
 * Animate a right chevron inside a button group.
 * Used to consistently signal a page / section transition to the user.
 *
 * You must set `role:group` or set the prop `data-group` on the parent
 * component which will trigger the animation.
 */
export function AnimatedChevronIcon({
  distance = "4px",
  transition = "transform 0.2s ease",
  ...props
}: AnimatedChevronIconProps): React.ReactElement {
  return (
    <Icon
      as={ChevronRightIcon}
      boxSize={5}
      flexShrink={0}
      transition={transition}
      sx={{
        "[role='group']:hover &": {
          transform: `translateX(${distance})`,
        },
        "[role='group']:focus-visible &": {
          transform: `translateX(${distance})`,
        },
        "[role='group'][data-focus-visible-added] &": {
          transform: `translateX(${distance})`,
        },

        "[data-group]:hover &": {
          transform: `translateX(${distance})`,
        },
        "[data-group]:focus-visible &": {
          transform: `translateX(${distance})`,
        },
        "[data-group][data-focus-visible-added] &": {
          transform: `translateX(${distance})`,
        },
      }}
      {...props}
    />
  );
}
